import React from 'react';
import { Flex } from 'antd';

import BulkEntryCommonProperties from '@totem/components/ticketing/details/timeEntry/bulkTimeEntry/bulkEntryCommonProperties';
import BulkTimeEntryContainer from '@totem/components/ticketing/details/timeEntry/bulkTimeEntry/bulkTimeEntryContainer';
import BulkTimeEntryTable from '@totem/components/ticketing/details/timeEntry/bulkTimeEntry/bulkTimeEntryTable';
import BulkTImeSubmitButton from '@totem/components/ticketing/details/timeEntry/bulkTimeEntry/bulkTImeSubmitButton';
import BulkTimeTotalHoursPending from '@totem/components/ticketing/details/timeEntry/bulkTimeEntry/bulkTimeTotalHoursPending';
import BulkUtilizationView from '@totem/components/ticketing/details/timeEntry/bulkTimeEntry/bulkUtilizationView';

const BulkTimeEntryLayout = () => {
  return (
    <BulkTimeEntryContainer>
      <Flex justify="space-between" align={'center'}>
        <BulkEntryCommonProperties />
        <div>
          <BulkTimeTotalHoursPending />
          <BulkTImeSubmitButton />
        </div>
      </Flex>
      <hr />
      <BulkTimeEntryTable />
      <br />
      <hr />
      <br />
      <BulkUtilizationView />
    </BulkTimeEntryContainer>
  );
};

export default BulkTimeEntryLayout;
